import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find-last-index.js";
import { mapGetters, mapActions } from 'vuex';
import dialogRule from './dialogRule.vue';
export default {
  data() {
    return {
      showOperate: false,
      //   redList: [],
      lineActiveWidth: 0,
      showDiaglog: false,
      ruleTempArr: [{
        img: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/yunying/default/huodongguize%402x.png',
        type: 'rule'
      }, {
        img: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/yunying/dark/kaquanzhongxin%402x.png',
        type: 'coupon'
      }]
    };
  },
  props: {
    visibleOperate: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  components: {
    dialogRule
  },
  watch: {
    async isLogin(val) {
      if (val && this.visibleOperateTop) {
        await this.getCheckIn();
        this.addTask();
      }
    },
    checkInList: {
      handler(val) {
        this.$emit('showOpreate', false);
      },
      deep: true
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters('login', ['isLogin'])), mapGetters('operateTask', ['checkInList', 'isOperateFailed', 'taskNumObj', 'awardObj', 'isAward'])), {}, {
    curTaskText() {
      let {
        task_done_num
      } = this.checkInList;
      const {
        num = 0,
        total = 0
      } = this.taskNumObj;
      if (task_done_num === 1) {
        const text = this.awardObj && this.awardObj.type === 1 ? '现金红包' : '优惠券';
        if (num < total && total !== 0) {
          return '今日第二次任务进行中，完成即可获得红包奖励哦，继续刷攻略吧！';
        }
        return `今日第一次任务已完成，恭喜获得${text}，点击卡劵中心查看`;
      }
      if (task_done_num === 2) {
        if (num < total && total !== 0) {
          return '今日第三次任务进行中，完成即可获得红包奖励！';
        }
        return '今日第二次任务已完成，恭喜获得优惠券，点击卡劵中心查看';
      }
      if (task_done_num === 3) {
        return '今日任务已全部完成，明天继续还可获得红包奖励！';
      }
      return '';
    },
    redList() {
      const chekeInList = this.checkInList.history && this.checkInList.history.map((item, index) => {
        const taskDay = `第${index + 1}天`;
        const checked = item.task_done_num > 0;
        let totalText = '';
        if (checked) {
          totalText = `${item.task_done_num}/${item.task_total}`;
        }
        if (item.task_done_num === 3) {
          totalText = '已领取';
        }
        let redImg = 'https://map-mobile-resource.cdn.bcebos.com/icon/service/yunying/dark/1hongbao%402x.png';
        if (checked) {
          redImg = 'https://map-mobile-resource.cdn.bcebos.com/icon/service/yunying/dark/hongbaolingqu%402x.png';
        }
        if ([2, 4, 6].includes(index)) {
          redImg = 'https://map-mobile-resource.cdn.bcebos.com/icon/service/yunying/default/hongbao2%402x.png';
          if (checked) {
            redImg = 'https://map-mobile-resource.cdn.bcebos.com/icon/service/yunying/default/hongbaolingqu2%402x.png';
          }
        }
        return _objectSpread({
          taskDay,
          checked,
          totalText,
          redImg
        }, item);
      });
      this.getLineWidth();
      return chekeInList;
    },
    visibleOperateTop() {
      return this.checkInList.history && this.checkInList.history.length > 0 && this.isLogin;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('login', ['goLogin'])), mapActions('operateTask', ['getCheckIn', 'addTask'])), {}, {
    operateClick() {
      if (!this.isLogin) {
        this.goLogin();
      }
    },
    // 设置进度条宽度样式
    getLineWidth() {
      this.$nextTick(() => {
        if (this.visibleOperateTop) {
          let {
            day,
            history = []
          } = this.checkInList;
          let curDay = history.findLastIndex(item => item.task_done_num > 0) || 0;
          const item = history[curDay] || {};
          if (item.task_done_num) {
            curDay = curDay * 1.5 + 1;
            // 活动到最后一天, 进度条撑满
            if (day === history.length) {
              curDay = curDay + 1;
            }
          }
          const width = this.$refs.redLine.clientWidth / 11 * curDay;
          this.lineActiveWidth = width;
        }
      });
    },
    handleClickJump(item = {
      type: ''
    }) {
      if (item.type === 'rule') {
        this.showDiaglog = true;
      } else {
        /* eslint-disable max-lines */
        const url = 'baidumap://map/cost_share?url=https%3A%2F%2Fcarowner.baidu.com%2ForderCenter%2Fcoupon.html&transparentWeb=0&navigationStatus=2&hiddenBackBtn=1&hiddenTitle=1&popRoot=no';
        window.location.href = url;
      }
    },
    closeDialogBox() {
      this.showDiaglog = false;
    },
    showOpreate() {
      this.$emit('showOpreate', !this.visibleOperate);
    }
  })
};